import type { DefaultTheme } from "styled-components";

export enum IconSize {
  XXS = "extraExtraSmall",
  XS = "extraSmall",
  SMALL = "small",
  MEDIUM = "medium",
  LARGE = "large",
  XL = "extraLarge",
  XXL = "extraExtraLarge",
  XXXL = "extraExtraExtraLarge",
}

export const sizeHandler = (
  size: IconSize | undefined,
  theme: DefaultTheme,
) => {
  let iconSize = 0;
  switch (size) {
    case IconSize.XXS:
      iconSize = theme.legacy.iconSizes.XXS;
      break;
    case IconSize.XS:
      iconSize = theme.legacy.iconSizes.XS;
      break;
    case IconSize.SMALL:
      iconSize = theme.legacy.iconSizes.SMALL;
      break;
    case IconSize.MEDIUM:
      iconSize = theme.legacy.iconSizes.MEDIUM;
      break;
    case IconSize.LARGE:
      iconSize = theme.legacy.iconSizes.LARGE;
      break;
    case IconSize.XL:
      iconSize = theme.legacy.iconSizes.XL;
      break;
    case IconSize.XXL:
      iconSize = theme.legacy.iconSizes.XXL;
      break;
    case IconSize.XXXL:
      iconSize = theme.legacy.iconSizes.XXXL;
      break;
    default:
      iconSize = theme.legacy.iconSizes.SMALL;
      break;
  }
  return iconSize;
};
